import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./ImageLeft.scss"

const ImageLeft = ({ section }) => {
  const url = section.image?.url
  const altText = section.image?.alt

  return (
    <section className="image-left">
      <Fade>
        <figure className="image-left__image">
          <img
            src={
              url ||
              "https://images.unsplash.com/photo-1640622659144-18a1fd885123?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
            }
            alt={altText}
            loading="lazy"
          />
          {section.image?.caption && (
            <figcaption>{section.image?.caption}</figcaption>
          )}
        </figure>
      </Fade>
      <div className="image-left__content">
        <Fade>
          <h2 className="image-left__content__title">
            {section.title || "Lorem Ipsum"}
          </h2>
          <p className="image-left__content__body">
            {section.body ||
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
          </p>
        </Fade>
      </div>
    </section>
  )
}

ImageLeft.propTypes = {
  section: PropTypes.object.isRequired,
}

export default ImageLeft
